import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface StaffManagementHeaderProps {
  isManager: boolean;
  onInviteClick: () => void;
}

export function StaffManagementHeader({
  isManager,
  onInviteClick,
}: StaffManagementHeaderProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {t("staffManagement.title")}
          </h1>
          <p className="text-muted-foreground mt-2">
            {isManager
              ? t("staffManagement.manageAllStaff")
              : t("staffManagement.manageStoreStaff")}
          </p>
        </div>

        <Button onClick={onInviteClick}>
          <UserPlus className="mr-2 h-4 w-4" />
          {t("inviteStaff")}
        </Button>
      </div>

      <Separator />
    </>
  );
}
